"use strict";

import React from "react"

function onFilterContextDidUpdate(prevFilterContext, curFilterContext, callback) {
    if (/*(prevFilterContext.selectedCountries.length !== curFilterContext.selectedCountries.length) ||
        (prevFilterContext.selectedPlatforms.length !== curFilterContext.selectedPlatforms.length) ||
        (prevFilterContext.selectedVideoPackages.length !== curFilterContext.selectedVideoPackages.length) ||
        (prevFilterContext.selectedGenreGroups.length !== curFilterContext.selectedGenreGroups.length) ||
        (prevFilterContext.selectedPrimaryGenres.length !== curFilterContext.selectedPrimaryGenres.length) ||
        (prevFilterContext.selectedSchedule !== curFilterContext.selectedSchedule)*/
        prevFilterContext.filterTimestamp !== curFilterContext.filterTimestamp) {
        callback();
    }
}

function filterContextToRequestParams(filterContext) {

    const selectedCountries = (filterContext.selectedCountries || []).flatMap(selected => selected.value.split(","));
    const selectedPlatforms = (filterContext.selectedPlatforms || []).flatMap(selected => selected.value.split(","));
    const selectedVideoPackages = (filterContext.selectedVideoPackages || []).flatMap(selected => selected.value.split(","));
    const selectedChannels = (filterContext.selectedChannels || []).flatMap(selected => selected.value.split(","));
    const selectedGenreGroups = (filterContext.selectedGenreGroups || []).flatMap(selected => selected.value.split(","));
    const selectedPrimaryGenres = (filterContext.selectedPrimaryGenres || []).flatMap(selected => selected.value.split(","));
    const selectedGenreTags = (filterContext.selectedGenreTags || []).flatMap(selected => selected.value.split(","));
    const selectedSchedule = (filterContext.selectedSchedule || "CURRENT");
    let params = {
        countryCodes: selectedCountries,
        platformIds: selectedPlatforms,
        videoPackageIds: selectedVideoPackages,
        channelTags: selectedChannels,
        schedule: selectedSchedule,
        genreGroups: selectedGenreGroups,
        primaryGenres: selectedPrimaryGenres,
        genreTags: selectedGenreTags,
    };
    return params;
}

export {
    onFilterContextDidUpdate,
    filterContextToRequestParams,
};
